import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const notificationsRoutes: RouteObject[] = [
  {
    path: ':id?',
    lazy: () =>
      import('./notification-list/NotificationListTab').then((m) => ({
        Component: m.NotificationListTab,
      })),
  },
  {
    path: ':id/:organization_id',
    lazy: () =>
      import('./notification-list/NotificationListTab').then((m) => ({
        Component: m.NotificationListTab,
      })),
  },
  {
    path: 'my-settings',
    lazy: () =>
      import('./my-settings/NotificationMemberSettingsScreen').then((m) => ({
        Component: m.NotificationMemberSettingsScreen,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/notifications"
        linkText="Go back to notifications"
      />
    ),
  },
];
